import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/lib/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  // Locale global: todos los textos propios de Vuetify (paginación de
  // v-data-table, "no data", "no results", mensajes de v-select, etc.) salen
  // en español sin tener que pasar footer-props en cada componente.
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    customVariables: ["src/sass/styles.sass"],
    treeShake: true,

    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#50b565",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "md",
  },
});
